"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARViewer = void 0;
class ARViewer {
    constructor() {
        this.modelUrl = null;
        this.banner = null;
    }
    get composedActionURL() {
        const link = new URL(location.href);
        link.searchParams.set("plattar_ar_action", "true");
        return encodeURI(link.href);
    }
}
exports.ARViewer = ARViewer;
